import {
  ApplicationConfig, DEFAULT_CURRENCY_CODE,
  ErrorHandler,
  inject,
  LOCALE_ID,
  provideAppInitializer,
  provideZoneChangeDetection
} from '@angular/core';
import {provideRouter, Router} from '@angular/router';

import {routes} from './app.routes';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {provideHttpClient} from '@angular/common/http';
import {provideApollo} from 'apollo-angular';
import {HttpLink} from 'apollo-angular/http';
import {ApolloLink, InMemoryCache} from '@apollo/client/core';
import {environment} from '../environments/environment';
import {setContext} from '@apollo/client/link/context';
import * as Sentry from '@sentry/angular';
import {TraceService} from '@sentry/angular';
import localeDa from '@angular/common/locales/da';
import {registerLocaleData} from '@angular/common';

registerLocaleData(localeDa);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(),
    provideHttpClient(),
    {
      provide: LOCALE_ID,
      useValue: 'da-DK'
    },
    {
      provide: DEFAULT_CURRENCY_CODE,
      useValue: ''
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideAppInitializer(() => {
      inject(TraceService);
    }),
    provideApollo(() => {
      const httpLink = inject(HttpLink);

      const auth = setContext((operation, context) => {
        const username = localStorage.getItem('employee_username');
        return {
          headers: {
            Authorization: `Basic ${btoa(username + ':' + environment.magento.flexposApiKey)}`,
          }
        };
      })

      return {
        link: ApolloLink.from(
          [
            auth,
            httpLink.create({
              uri: environment.magento.graphql,
            })
          ]
        ),
        headers: {},
        cache: new InMemoryCache(),
      };
    })
  ]
};
